import { render, staticRenderFns } from "./AssessmentBuilder.vue?vue&type=template&id=0013781e&scoped=true&"
import script from "./AssessmentBuilder.vue?vue&type=script&lang=js&"
export * from "./AssessmentBuilder.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentBuilder.vue?vue&type=style&index=0&id=0013781e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013781e",
  null
  
)

component.options.__file = "AssessmentBuilder.vue"
export default component.exports